import * as React from 'react';
import { Button } from '@duxton-web/ui';

export interface EditButtonSectionProps {
  handleEditButtonClicked?: () => void;
  handleCancelEditButtonClicked?: () => void;
  isEditRolloutButtonClicked: boolean;
  disabled: boolean;
}

export interface EditButtonSectionStates {}

export class EditButtonSection extends React.Component<
  EditButtonSectionProps,
  EditButtonSectionStates
> {
  render() {
    const {
      isEditRolloutButtonClicked,
      handleCancelEditButtonClicked,
      handleEditButtonClicked,
      disabled,
    } = this.props;

    return (
      <div>
        <Button
          size="small"
          type="primary"
          style={{
            background: '#e8e8e8',
            color: disabled ? '#707070' : '#3d3d3d',
            border: '1px solid #E8E8E8',
          }}
          onClick={
            isEditRolloutButtonClicked
              ? handleCancelEditButtonClicked
              : handleEditButtonClicked
          }
          disabled={!isEditRolloutButtonClicked && disabled}
        >
          {isEditRolloutButtonClicked ? 'Cancel' : 'Edit Changes'}
        </Button>
      </div>
    );
  }
}

export default EditButtonSection;
